<template>
	<div class="container-fluid" id="next-options">
    <Navigation></Navigation>
		<div class="row wrapper">
			<div class="col-12 col-md-4 side-banner">
				<div class="header">
					<!-- <div id="steps" class="steps" tabindex="0" role="document">
						<span>Step {{ step }}</span> of {{ steps }}
					</div> -->
          <div class="company-logo"></div>
					<h1 tabindex="0">Member type</h1>
					<div class="hero-image" alt="About you"></div>
				</div>
			</div>

			<div class="col-12 col-md-8 main-banner">
				<div class="main">

					<ValidationObserver v-slot="{ valid }" ref="form">
            <form @submit.prevent="onSubmit" @keydown.enter="$event.preventDefault()">
              <div class="form-group">
                <ValidationProvider mode="lazy" name="age" :rules="'required:'+pageContent.pages.about.outOfRangeErrorMessage+'|between:'+config.fields.age.min+','+config.fields.age.max+','+pageContent.pages.about.outOfRangeErrorMessage" v-slot="{ errors, failedRules }">
                  <label for="age" tabindex="0">Your age</label>
                  <cleave
                    ref="age"
                    data-analytics-capture-value="true"
                    :options="formatOptions.age"
                    class="form-control"
                    id="age"
                    name="age"
                    v-model.number="data.stepData.age"
                    type="text"
                    tabindex="0"
                    v-on:blur="updateAgeRelatedFieldValues"
                    @keydown.native.enter.prevent="$refs.gender.focus()">
                  </cleave>
                  <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
                  <span v-if="failedRules.between && pageContent.pages.about.infoBoxError" v-html="pageContent.pages.about.infoBoxError"></span>
                  <span v-if="data.stepData.age >= 67 && data.stepData.age < 74 && pageContent.pages.about.infoBoxErrorIP" v-html="pageContent.pages.about.infoBoxErrorIP"></span>
                  <span v-if="data.stepData.age == 74 && pageContent.pages.about.infoBoxErrorIPTPD" v-html="pageContent.pages.about.infoBoxErrorIPTPD"></span>
                </ValidationProvider>
              </div>

              <div class="form-group">
                <ValidationProvider name="gender" :rules="'required:'+pageContent.pages.about.genderRequiredErrorMessage" v-slot="{ errors }">
                  <div class="row no-gutters">
                    <div class="col-auto"><label tabindex="0">Your sex at birth</label></div>
                    <div class="col-auto">
                      <b-button id="tooltip-gender" variant="tooltip" aria-label="tooltip gender"><i class="icon-help mb-0"></i></b-button>
                      <b-tooltip target="tooltip-gender" placement="top">
                        {{pageContent.pages.about.tooltipGender}}
                      </b-tooltip>
                      <!-- todo -->
                    </div>
                  </div>
                  <select ref="gender" id="gender" class="form-control"
                    v-model="data.stepData.gender" tabindex="0" aria-label="gender" @change="triggerHeightCheck()"
                    @keydown.enter.prevent="$refs[`salary${data.stepData.salaryPeriod}ly`].$el.focus()">
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </select>
                  <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- TODO extract as Component & use in Income page -->

              <div class="form-group">
                <div class="row no-gutters">
                  <div class="col-8">
                    <div v-if="data.stepData.salaryPeriod === 'Year'">
                      <ValidationProvider ref="salaryYearlyVp" mode="lazy" name="salaryYearly" :rules="'required:'+pageContent.pages.income.ipSalaryError+'|between:'+config.fields.ipSalaryYearly.min+','+config.fields.ipSalaryYearly.max+','+pageContent.pages.income.ipSalaryError" v-slot="{ errors }">
                        <div class="row no-gutters">
                          <div class="col-auto"><label for="salaryYearly" tabindex="0">Salary</label></div>
                          <div class="col-auto">
                            <b-button id="tooltip-salary-yearly" variant="tooltip" aria-label="tooltip salary yearly"><i class="icon-help mb-0"></i></b-button>
                            <b-tooltip target="tooltip-salary-yearly" placement="top">
                              Before tax and excluding super contributions.
                            </b-tooltip>
                          </div>
                        </div>
                        <cleave
                          ref="salaryYearly"
                          data-analytics-capture-value="true"
                          :options="formatOptions.moneys"
                          class="form-control"
                          id="salaryYearly"
                          name="salaryYearly"
                          v-model.number="data.stepData.salaryYearly"
                          v-on:blur="triggerHeightCheck"
                          type="text"
                          tabindex="0"
                          @keydown.native.enter.prevent="$refs.salaryPeriod.focus()">
                        </cleave>
                        <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                      </ValidationProvider>
                    </div>
                    <div v-if="data.stepData.salaryPeriod === 'Month'">
                      <ValidationProvider ref="salaryMonthlyVp" mode="lazy" name="salaryMonthly" :rules="'required:'+pageContent.pages.income.ipSalaryError+'|between:'+config.fields.ipSalaryMonthly.min+','+config.fields.ipSalaryMonthly.max+','+pageContent.pages.income.ipSalaryError" v-slot="{ errors }">
                        <div class="row no-gutters">
                          <div class="col-auto"><label for="salaryMonthly" tabindex="0">Salary</label></div>
                          <div class="col-auto">
                            <b-button id="tooltip-salary-monthly" variant="tooltip" aria-label="tooltip salary monthly"><i class="icon-help mb-0"></i></b-button>
                            <b-tooltip target="tooltip-salary-monthly" placement="top">
                              Before tax and excluding super contributions.
                            </b-tooltip>
                          </div>
                        </div>
                        <cleave
                          ref="salaryMonthly"
                          data-analytics-capture-value="true"
                          :options="formatOptions.moneys"
                          class="form-control"
                          id="salaryMonthly"
                          name="salaryMonthly"
                          v-model.number="data.stepData.salaryMonthly"
                          v-on:blur="triggerHeightCheck"
                          type="text"
                          tabindex="0"
                          @keydown.native.enter.prevent="$refs.salaryPeriod.focus()">
                        </cleave>
                        <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                      </ValidationProvider>
                    </div>
                    <div v-if="data.stepData.salaryPeriod === 'Week'">
                      <ValidationProvider ref="salaryWeeklyVp" mode="lazy" name="salaryWeekly" :rules="'required:'+pageContent.pages.income.ipSalaryError+'|between:'+config.fields.ipSalaryWeekly.min+','+config.fields.ipSalaryWeekly.max+','+pageContent.pages.income.ipSalaryError" v-slot="{ errors }">
                        <div class="row no-gutters">
                          <div class="col-auto"><label for="salaryWeekly" tabindex="0">Salary</label></div>
                          <div class="col-auto">
                            <b-button id="tooltip-salary-weekly" variant="tooltip" aria-label="tooltip salary weekly"><i class="icon-help mb-0"></i></b-button>
                            <b-tooltip target="tooltip-salary-weekly" placement="top">
                              Before tax and excluding super contributions.
                            </b-tooltip>
                          </div>
                        </div>
                        <cleave
                          ref="salaryWeekly"
                          data-analytics-capture-value="true"
                          :options="formatOptions.moneys"
                          class="form-control"
                          id="salaryWeekly"
                          name="salaryWeekly"
                          v-model.number="data.stepData.salaryWeekly"
                          v-on:blur="triggerHeightCheck"
                          type="text"
                          tabindex="0"
                          @keydown.native.enter.prevent="$refs.salaryPeriod.focus()">
                        </cleave>
                        <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }" v-html="errors[0]"></span>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-4 pl-2">
                    <label for="salaryPeriod" tabindex="0">Per</label>
                    <select ref="salaryPeriod" id="salaryPeriod" class="form-control" aria-label="Default select example"
                      v-model="data.stepData.salaryPeriod" tabindex="0" @change="triggerHeightCheck()">
                      <option value="Year">Year</option>
                      <option value="Month">Month</option>
                      <option value="Week">Week</option>
                    </select>
                  </div>
                </div>
              </div>

              <!---->

							<div v-if="!data.stepData.memberTypeHidden" class="form-group max">
                <ValidationProvider name="memberType" :rules="'required:'+pageContent.pages.about.memberTypeRequiredErrorMessage" v-slot="{ errors }">
                  <div v-html="pageContent.pages.memberTypeDescriptions.intro"></div>
                  <div class="row d-flex justify-content-between card-wrapper account-selection">

                    <b-card v-if="pageContent.pages.memberTypeDescriptions.employer"
                      :title="`${pageContent.pages.memberTypeDescriptions.employer.header}`"
                      class="col-lg-12 col-xl-4 p-0" :class="{ active: data.stepData.memberType == Enum.memberType.EMPLOYER }">
                      <b-card-body
                        class="p-0"
                        v-show="pageContent.pages.memberTypeDescriptions.employer.details"
                        v-html="pageContent.pages.memberTypeDescriptions.employer.details">
                      </b-card-body>
                      <b-card-text>
                        <input tabindex="0" type="radio" id="employer" name="memberType" v-model="data.stepData.memberType" :value="Enum.memberType.EMPLOYER" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                        {{ pageContent.pages.memberTypeDescriptions.employer.description }}
                      </b-card-text>
                      <b-button @click="toggleMemberTypeBtn(Enum.memberType.EMPLOYER)" :class="{ active: data.stepData.memberType == Enum.memberType.EMPLOYER }">Select</b-button>
                    </b-card>

                    <b-card :title="`${pageContent.pages.memberTypeDescriptions.personal.header}`"
                      class="col-lg-12 p-0" :class="{ active: data.stepData.memberType == Enum.memberType.PERSONAL, disabled: disableMemberTypePersonalBasedOnAge, 'col-xl-4': !pageContent.pages.memberTypeDescriptions.special, 'col-xl-6': pageContent.pages.memberTypeDescriptions.special }">
                      <b-card-body
                        class="p-0"
                        v-show="pageContent.pages.memberTypeDescriptions.personal.details"
                        v-html="pageContent.pages.memberTypeDescriptions.personal.details">
                      </b-card-body>
                      <b-card-text>
                        <input tabindex="0" type="radio" id="personal" name="memberType" v-model="data.stepData.memberType" :value="Enum.memberType.PERSONAL" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                        {{ pageContent.pages.memberTypeDescriptions.personal.description }}
                      </b-card-text>
                      <b-button @click="toggleMemberTypeBtn(Enum.memberType.PERSONAL)" :disabled="disableMemberTypePersonalBasedOnAge" :class="{ active: data.stepData.memberType == Enum.memberType.PERSONAL }">Select</b-button>
                    </b-card>

                    <b-card v-if="pageContent.pages.memberTypeDescriptions.merged"
                      :title="`${pageContent.pages.memberTypeDescriptions.merged.header}`"
                      class="col-lg-12 col-xl-4 p-0" :class="{ active: data.stepData.memberType == Enum.memberType.MERGED }">
                      <b-card-body
                        class="p-0"
                        v-show="pageContent.pages.memberTypeDescriptions.merged.details"
                        v-html="pageContent.pages.memberTypeDescriptions.merged.details">
                      </b-card-body>
                      <b-card-text>
                        <input tabindex="0" type="radio" id="merged" name="memberType" v-model="data.stepData.memberType" :value="Enum.memberType.MERGED" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                        {{ pageContent.pages.memberTypeDescriptions.merged.description }}
                      </b-card-text>
                      <b-button @click="toggleMemberTypeBtn(Enum.memberType.MERGED)" :class="{ active: data.stepData.memberType == Enum.memberType.MERGED }">Select</b-button>
                    </b-card>

                    <b-card v-if="pageContent.pages.memberTypeDescriptions.special"
                      :title="`${pageContent.pages.memberTypeDescriptions.special.header}`"
                      class="col-lg-12 col-xl-6 p-0" :class="{ active: data.stepData.memberType == Enum.memberType.SPECIAL }">
                      <b-card-body
                        class="p-0"
                        v-show="pageContent.pages.memberTypeDescriptions.special.details"
                        v-html="pageContent.pages.memberTypeDescriptions.special.details">
                      </b-card-body>
                      <b-card-text>
                        <input tabindex="0" type="radio" id="special" name="memberType" v-model="data.stepData.memberType" :value="Enum.memberType.SPECIAL" @click="triggerHeightCheck()" data-analytics-capture-value="true">
                        {{ pageContent.pages.memberTypeDescriptions.special.description }}
                      </b-card-text>
                      <b-button @click="toggleMemberTypeBtn(Enum.memberType.SPECIAL)" :class="{ active: data.stepData.memberType == Enum.memberType.SPECIAL }">Select</b-button>
                    </b-card>
                    <span role="alert" class="form-text" v-bind:class="{ 'text-error': errors.length > 0 }">{{ errors[0] }}</span>

                    <div
                      class="mt-3"
                      v-show="pageContent.pages.memberTypeDescriptions.explanation"
                      v-html="pageContent.pages.memberTypeDescriptions.explanation">
                    </div>
									</div>
                </ValidationProvider>
							</div>

							<div class="nav-button row" >
								<router-link class="assumption-button col" :to="{ name: 'Disclaimer', params: {activeTab: 'disclaimer' } }" tabindex="0" role="button"><i class="icon-info disclaimer"></i>Disclaimer </router-link>
								<router-link class="back-button col" :to="backDestination" tabindex="0" role="button">Back </router-link>
								<button class="next-button col" v-bind:class="[valid ? 'is-active' : 'is-disabled']"  type="submit" tabindex="0" role="button">Next</button>
							</div>

						</form>
					</ValidationObserver>

				</div>
			</div>
		</div>
		<CustomFooter></CustomFooter>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from "vuex-map-fields";
import Cleave from "vue-cleave-component";

import { ValidationProvider, extend, ValidationObserver } from 'vee-validate';
import { required, between } from 'vee-validate/dist/rules';
import CustomFooter from '../components/CustomFooter';
import Navigation from "../components/Navigation.vue";

import _ from 'lodash';

extend('required', {
  ...required,
  params: ['msg'],
  message: '{msg}'
});
extend('between', {
  ...between,
  params: ['min', 'max', 'msg'],
  validate(value, { min, max }) {
    return value >= min && value <= max;
  },
  message: '{msg}'
});

export default {
  name: 'NextOptions',
	props: ['from'],
  components: { Cleave, ValidationProvider, ValidationObserver, CustomFooter, Navigation },
  computed: {
    ...mapFields(["data", "skipCalculations", "prevTab"]),
    ...mapGetters(["Enum", "config", "formatOptions", "pageContent", "occupations"]),
		backDestination() {
			return this.skipCalculations ? { name: 'Intro', params: { choice: 'next-options' } } : "/results";
		},
    disableMemberTypePersonalBasedOnAge() {
      let disable = false
      if(this.data.stepData.age == 14) {
        disable = true;
      }
      return disable
    },
    step() {
      return this.skipCalculations ? 1 : 6;
    },
    steps() {
      return this.skipCalculations ? 2 : 7;
    }
  },
  methods: {
    ...mapActions(["validateSalary"]),
    toggleMemberTypeBtn(memberType) {
      this.data.stepData.memberType = memberType;
      this.triggerHeightCheck();
    },
    updateAgeRelatedFieldValues: function() {
      this.$store.commit("updateAgeRelatedFieldValues");
			this.$store.commit("setLifeInsurancePaymentPeriod");
      this.triggerHeightCheck();
		},
    triggerHeightCheck: function() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function() {
        rf.$refreshIframeHeight();
      }, 300);
    },
    onSubmit () {
      this.$refs.form.validateWithInfo().then(result => {
        if (!result.isValid) {
          var fieldArr = _.valuesIn(result.fields);
          var firstError = document.getElementById(fieldArr[0].id)
          if(firstError) {
            firstError.scrollIntoView({behavior: 'smooth'});
          }
          this.triggerHeightCheck();
          return;
        }
        this.prevTab = 6;
				if(this.data.stepData.memberType === this.Enum.memberType.PERSONAL && !this.data.stepData.occupationHidden) {
					this.$router.push('/occupation');
				} else {
					this.$router.push('/cover-cost');
				}
      });
    },
  },
  mounted() {
    //load defaults
    this.triggerHeightCheck();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
    this.validateSalary(this.$refs);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
  beforeDestroy() {
    // send analytics - complete form step
    const stepData = this.data.stepData;
    const salaryPeriod = stepData.salaryPeriod;
    var dataObj = {
      "age": stepData.age,
      "gender": stepData.gender,
      "memberType": stepData.memberType,
      "salary": salaryPeriod === "Month" ? stepData.salaryMonthly :
        salaryPeriod === "Week" ? stepData.salaryWeekly : stepData.salaryYearly,
      "salaryPeriod": salaryPeriod
    };
    this.$gtag.event('step-about-quote', { event_category: 'form-step-progress', event_label: JSON.stringify(dataObj) });
  }
};
</script>
